//#region src/qsr_automations_mode.ts
var QsrAutomationsMode = /* @__PURE__ */ function(QsrAutomationsMode) {
	QsrAutomationsMode["Sending"] = "sending-and-webhooks";
	QsrAutomationsMode["PosWebhooks"] = "pos-webhooks";
	return QsrAutomationsMode;
}(QsrAutomationsMode || {});
//#endregion
export { QsrAutomationsMode };

//# sourceMappingURL=qsr_automations_mode.js.map